var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1992 22C17.7221 22 22.1992 17.5228 22.1992 12C22.1992 6.47715 17.7221 2 12.1992 2C6.67637 2 2.19922 6.47715 2.19922 12C2.19922 17.5228 6.67637 22 12.1992 22Z",
    fill: "#FAC800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 16L12.1992 11",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2012,
    cy: 7,
    r: 1,
    transform: "rotate(-180 12.2012 7)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoYellow);
export default __webpack_public_path__ + "static/media/info-yellow.8186a896987e1d58edbafe79edc829ba.svg";
export { ForwardRef as ReactComponent };